export const API_ROUTE_ROOT = '/api'
export const API_ROUTE_STATUS = `${API_ROUTE_ROOT}/status`